import { SagaIterator } from "redux-saga";
import * as Effects from "redux-saga/effects";
import { localizedStrings } from "../../../common/localization/LocalizedStrings";
import { IRapPageContext } from "../../../platform/Context";
import { ActionsOfType } from "../../../platform/redux/ActionHelper";
import * as LocalConstants from "../../../common/Constants";
import { TestActionTypes, TestActionsType, TestActions } from "./TestActions";
import { IUhfApiClient } from "../../../contracts/swagger/_generated";

const takeEvery: any = Effects.takeEvery;
const call: any = Effects.call;
const put: any = Effects.put;
const getContext: any = Effects.getContext;
const select: any = Effects.select;
const apply: any = Effects.apply;
const take: any = Effects.take;

export function* testSaga(): SagaIterator {
    yield takeEvery(TestActionTypes.FetchPartnerList, fetchPartnerList);
    yield takeEvery(TestActionTypes.FetchPartnerHeaders, fetchPartnerHeaders);
    yield takeEvery(TestActionTypes.FetchPartnerFooters, fetchPartnerFooters);
}

export function* fetchPartnerList(action: ActionsOfType<TestActionsType, TestActionTypes.FetchPartnerList>): SagaIterator {
    const pageContext: any = yield getContext("pageContext");
    if (pageContext) {
        try {
            const context = pageContext as IRapPageContext;
            const UhfClient: IUhfApiClient = ((yield call([context, context.getRestClient], "IUhfApiClient")) as unknown) as IUhfApiClient;

            const response: string[] = ((yield call(
                [UhfClient, UhfClient.getPartnersList],
            )) as unknown) as string[];

            action.resolve(response);
            yield put(TestActions.fetchPartnerListSuccess(response));
        } catch (error) {
            console.error(error);
            var errorCode = (error as any).status;
            let message: string = localizedStrings.Errors.serverError;
            if (errorCode) message = errorCode == LocalConstants.HttpErrorCodes.UnAuthorized ? localizedStrings.App.unauthorized : localizedStrings.Errors.serverError;
            action.reject(message);
            yield put(TestActions.fetchPartnerListFailure(message));
        }
    } else {
        yield put(TestActions.fetchPartnerListFailure("IdToken token is invalid."));
    }
}

export function* fetchPartnerHeaders(action: ActionsOfType<TestActionsType, TestActionTypes.FetchPartnerHeaders>): SagaIterator {
    const pageContext: any = yield getContext("pageContext");
    if (pageContext) {
        try {
            const partnerId = action.payload;
            const context = pageContext as IRapPageContext;
            const UhfClient: IUhfApiClient = ((yield call([context, context.getRestClient], "IUhfApiClient")) as unknown) as IUhfApiClient;

            const response: string[] = ((yield call(
                [UhfClient, UhfClient.getPartnerHeaders],
                partnerId
            )) as unknown) as string[];

            action.resolve(response);
            yield put(TestActions.fetchPartnerHeadersSuccess(response));
        } catch (error) {
            console.error(error);
            var errorCode = (error as any).status;
            let message: string = localizedStrings.Errors.serverError;
            if (errorCode) message = errorCode == LocalConstants.HttpErrorCodes.UnAuthorized ? localizedStrings.App.unauthorized : localizedStrings.Errors.serverError;
            action.reject(message);
            yield put(TestActions.fetchPartnerHeadersFailure(message));
        }
    } else {
        yield put(TestActions.fetchPartnerHeadersFailure("IdToken token is invalid."));
    }
}

export function* fetchPartnerFooters(action: ActionsOfType<TestActionsType, TestActionTypes.FetchPartnerFooters>): SagaIterator {
    const pageContext: any = yield getContext("pageContext");
    if (pageContext) {
        try {
            const partnerId = action.payload;
            const context = pageContext as IRapPageContext;
            const UhfClient: IUhfApiClient = ((yield call([context, context.getRestClient], "IUhfApiClient")) as unknown) as IUhfApiClient;

            const response: string[] = ((yield call(
                [UhfClient, UhfClient.getPartnerFooters],
                partnerId
            )) as unknown) as string[];

            action.resolve(response);
            yield put(TestActions.fetchPartnerFootersSuccess(response));
        } catch (error) {
            console.error(error);
            var errorCode = (error as any).status;
            let message: string = localizedStrings.Errors.serverError;
            if (errorCode) message = errorCode == LocalConstants.HttpErrorCodes.UnAuthorized ? localizedStrings.App.unauthorized : localizedStrings.Errors.serverError;
            action.reject(message);
            yield put(TestActions.fetchPartnerFootersFailure(message));
        }
    } else {
        yield put(TestActions.fetchPartnerFootersFailure("IdToken token is invalid."));
    }
}

